module.exports = __webpack_public_path__ + "static/img/chat-pass.0172747e.png";